export const TRADE_TYPES = {
  EXPORT: 'Export',
  IMPORT: 'Import'
}

export const LANGUAGES = {
  ENGLISH: 'English',
  TURKISH: 'Turkish'
}

export const tradeTypeOptions = [
  { value: TRADE_TYPES.EXPORT, label: TRADE_TYPES.EXPORT },
  { value: TRADE_TYPES.IMPORT, label: TRADE_TYPES.IMPORT }
]

export const languageOptions = [
  { value: LANGUAGES.ENGLISH, label: LANGUAGES.ENGLISH },
  { value: LANGUAGES.TURKISH, label: LANGUAGES.TURKISH }
]
